<script setup lang="ts">
interface Props {
  step: number;
  activeStep: number;
  stepsVisited: number;
  totalSteps: number;
  alertWarning?: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  (e: 'stepChange', step: number): void;
}>();
</script>

<template>
  <div>
    <div class="uk-flex uk-flex-row">
      <div class="uk-margin-right uk-position-relative">
        <div
          :class="{ 'step-number-disable': step > stepsVisited }"
          class="step-number uk-flex uk-flex-middle uk-flex-center uk-position-relative"
        >
          {{ step }}
        </div>
        <div v-if="step !== totalSteps" class="step-line uk-position-absolute"></div>
      </div>
      <div class="uk-width-1-1">
        <div
          :style="{
            cursor: step > stepsVisited ? 'default' : 'pointer',
            opacity: step > stepsVisited ? '0.5' : '1',
          }"
          @click="step <= stepsVisited && emit('stepChange', step)"
        >
          <slot name="header"></slot>
        </div>
        <div v-if="step === activeStep">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
    <div
      uk-alert
      v-if="alertWarning"
      class="uk-alert-warning uk-flex uk-margin-top warning-alert-custom"
      style="align-items: baseline"
    >
      <i uk-icon="warning" style="min-width: 1rem"></i>
      <span class="uk-margin-small-left uk-text-secondary uk-text-small"
        >Invitations can only be made to a finalized round, so be sure all edits are complete before
        sending.</span
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.step-number {
  background: #4a4c7b;
  width: 30px;
  height: 30px;
  margin-top: 10%;
  border-radius: 100px;
  color: white;
  z-index: 1;
  cursor: default;

  &-disable {
    background: #919393 !important;
  }
}

.step-line {
  width: 1px;
  background: black;
  height: 100%;
  margin-top: 10%;
  top: 0;
  left: 50%;
}
</style>
